import { Control, FieldErrors, FieldValues, Path } from "react-hook-form";
import { FormErrorMessage, InputProps, CheckboxProps } from "@chakra-ui/react";
import { Box } from "@familyzone/component-library";
import React from "react";
import { CheckBoxControl } from "./CheckboxControl";
import { FieldProps } from "./Common";
import { TextFieldControl } from "./TextFieldControl";

type FieldSubset<TFieldValues extends FieldValues, TFieldPath extends Path<TFieldValues> = Path<TFieldValues>> = Omit<
  FieldProps<TFieldValues, TFieldPath>,
  "label" | "tooltip" | "control" | "errors"
>;

type Props<
  TFieldValues extends FieldValues,
  TFieldPathCheckbox extends Path<TFieldValues> = Path<TFieldValues>,
  TFieldPathInput extends Path<TFieldValues> = Path<TFieldValues>
> = {
  label: string;
  control: Control<TFieldValues, TFieldPathInput>;
  errors: FieldErrors<TFieldValues>;
  inputFieldProps: FieldSubset<TFieldValues, TFieldPathInput>;
  checkboxFieldProps: FieldSubset<TFieldValues, TFieldPathCheckbox>;
  inputProps?: InputProps;
  checkboxProps?: CheckboxProps;
  tooltip?: string;
};

export const CheckboxTextComboControl = <
  TFieldValues extends FieldValues,
  TFieldPathCheckbox extends Path<TFieldValues> = Path<TFieldValues>,
  TFieldPathInput extends Path<TFieldValues> = Path<TFieldValues>
>({
  label,
  control,
  errors,
  inputFieldProps,
  checkboxFieldProps,
  inputProps,
  checkboxProps,
  tooltip,
}: Props<TFieldValues, TFieldPathCheckbox, TFieldPathInput>): JSX.Element => {
  const common = {
    control: control,
    errors: errors,
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: " column",
        gap: "8px",
      }}
    >
      <CheckBoxControl fieldProps={{ ...checkboxFieldProps, ...common, label: label, tooltip: tooltip }} inputProps={checkboxProps} />
      {!inputFieldProps.disabled && (
        <Box paddingLeft="38px">
          <TextFieldControl styleType="column" fieldProps={{ ...inputFieldProps, ...common }} inputProps={inputProps} />
          <FormErrorMessage>{errors[inputFieldProps.name] && errors[inputFieldProps.name]?.message}</FormErrorMessage>
        </Box>
      )}
    </Box>
  );
};
